import { Injectable } from '@angular/core';
import { User } from '../shared/user.model';

export type Role = 'administrator' | 'writer' | 'pageAddWriter' | 'contributor' | 'editor' | 'dmc';

@Injectable()
export class TeamService {
    roles: Role[] = ['writer', 'pageAddWriter', 'editor', 'dmc'];
    team = [];

    constructor() {}
    loadTeam(assignment) {
        if( !assignment ) {
            return;
        }
        const team = assignment.team;
        const availableRoles = this.roles;
        for(var i = 0; i < team.length; i++) {
            const member = new User(team[i]);
            for(var j = 0; j < availableRoles.length; j++) {
                const role = availableRoles[j];
                if( assignment.hasOwnProperty(role) && assignment[role] == member.id && member.roles.indexOf(role) === -1 ) {
                    member.roles.push(role);
                }
            }
            team[i] = member;
        }
        this.team = team;
        this.setFilteredRoles();
    }
    updateAssignment(e, assignment) {
        const action = e.action;
        if( !this[action] ) {
            return;
        }
        this[action](e.data, assignment);
        this.setFilteredRoles();
    }
    memberAdded(member) {}
    memberRemoved(member) {}
    roleAdded(data, assignment) {
        const role = data.role;
        const member = data.member;
        if( role == 'writer' && assignment.status == 'unassigned' ) {
            assignment.previousStatus = 'unassigned';
            assignment.status = 'assigned'; // change status to assigned
        }
        assignment[role] = member.id;
    }
    roleRemoved(data, assignment) {
        const role = data.role;
        const found = this.team.filter(item => item.roles.indexOf(role) !== -1);
        if( found.length > 0 ) {
            assignment[role] = found[0].id;
        } else {
            assignment[role] = 0;
            if( role == 'writer' && assignment.status == 'assigned' ) {
                assignment.previousStatus = 'assigned';
                assignment.status = 'unassigned'; // change status to unassigned
            }
        }
    }
    setFilteredRoles() {
        let team = this.team;
        for(var i = 0; i < team.length; i++) {
            let member = team[i];
            member.filteredRoles = this.getMemberRoles(member);
            if( member.filteredRoles.length == 0 ) {
                member.filteredRoles.push('follower');
            }
        }
    }
    getMemberRoles(member) {
        const roles = this.roles;
        return member.roles.filter(item => roles.indexOf(item) !== -1);
    }
}
